import { Mail, MapPin, Phone } from 'lucide-react';

import CrmLink from '@/components/common/CrmLink';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import useEmailClient from '@/features/email/hooks/useEmailClient';
import { getPartyAddress } from '@/lib/party';
import { getGoogleMapsLink } from '@/lib/utils/address';
import hasItems from '@/lib/utils/hasItems';
import isEmpty from '@/lib/utils/isEmpty';

import PartyDetail from './PartyDetail';

export default function PartyDetailsSection() {
  const party = useSelectedParty();
  const { openSendMail } = useEmailClient();

  if (!party) return null;

  const address = getPartyAddress(party);
  const addressLink = getGoogleMapsLink(address);
  const phone = party.telephonenr;
  const email = party.email;

  const hasAnyDetails =
    !isEmpty(address) ||
    Boolean(phone) ||
    Boolean(email) ||
    hasItems(party.external_refs);

  if (!hasAnyDetails) return null;

  return (
    <div className="flex flex-col gap-1">
      {hasItems(party.external_refs) && (
        <div className="flex flex-wrap gap-2 text-xs">
          {party.external_refs.map((ref) => (
            <CrmLink
              key={`${ref.company}-${ref.ref}`}
              ref={ref.ref}
              crm={ref.company}
            />
          ))}
        </div>
      )}

      <div className="flex gap-1">
        {email && (
          <PartyDetail
            icon={Mail}
            value={email}
            onClick={() => openSendMail({ to: [email] })}
          />
        )}

        {phone && (
          <PartyDetail href={`tel:${phone}`} icon={Phone} value={phone} />
        )}
      </div>

      {!isEmpty(address) && (
        <PartyDetail href={addressLink} icon={MapPin} value={address} />
      )}
    </div>
  );
}
